import { css } from '@emotion/react';
import { IonCard, IonContent } from '@ionic/react';
import React from 'react';

export const SidePanel: React.FC<{ topOffsetPixels: number; children: React.ReactNode }> = ({
  topOffsetPixels,
  children,
}) => {
  const sidePanelCss = {
    card: [
      css({
        margin: 0,
        position: 'absolute',
        top: topOffsetPixels,
        left: 0,
        width: 400,
        height: `calc(100vh - ${topOffsetPixels}px)`,
        display: 'flex',
        zIndex: 2,
        backgroundColor: 'white',
        '--background': 'transparent',
      }),
    ],
  };

  return (
    <IonCard css={sidePanelCss.card}>
      <IonContent>{children}</IonContent>
    </IonCard>
  );
};
